export function buildUrl(baseUrl: string, basePath: string, asPath: string, locale?: string | undefined): string {
    const basePathPart = basePath ? `/${basePath}` : ''
    const localePart = locale ? `/${locale}` : ''
    const finalUrl =
        `${baseUrl}${basePathPart}${localePart}${asPath}`

    return finalUrl
}